import { createActions, handleActions } from "redux-actions"

const { setConfiguration } = createActions("SET_CONFIGURATION")

const reducer = handleActions(
	{
		[setConfiguration]: (state, { payload }) => payload
	},
	{}
)

export { setConfiguration }
export default reducer



// WEBPACK FOOTER //
// ./src/redux/modules/configuration.js